import React, { type HTMLAttributes } from 'react';

export interface WorkiLogoProps extends HTMLAttributes<HTMLSpanElement> {
  /** Add a name when the logo is not already labelled by its surrounding link. */
  title?: string;
}

/**
 * Worki's approved wordmark, painted from the canonical traced SVG mask.
 *
 * A mask keeps the production silhouette identical to the exported asset while
 * still allowing every surface to inherit the configured accent via `color`.
 */
export function WorkiLogo({ title, className, ...props }: WorkiLogoProps) {
  const accessible = Boolean(title);

  return (
    <span
      className={['worki-logo', className].filter(Boolean).join(' ')}
      role={accessible ? 'img' : undefined}
      aria-label={accessible ? title : undefined}
      aria-hidden={accessible ? undefined : true}
      {...props}
    />
  );
}
